export default "__VITE_ASSET__f$G6zby0__"